var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['changeMapType', {active: _vm.active}],on:{"click":_vm.handleClick}},[(_vm.img)?_c('img',{attrs:{"src":_vm.img}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }